// import {ScrollLock} from './utils/scroll-lock.js';
import { FocusLock } from './utils/focus-lock.js';
import { initMenu } from './modules/menu/init-menu.js';
import { CustomSelect } from './modules/select/custom-select.js';
import { Accordions } from './modules/accordions.js';
import { Tabs } from './modules/tabs.js';

const breakPointMobile = 767;

window.addEventListener('DOMContentLoaded', () => {
  document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
  // const scrollLock = new ScrollLock();
  const focusLock = new FocusLock('startFocus: true');
  initMenu();

  // Подключаем новый плагин для select
  const select = new CustomSelect();
  select.init();

  // Accordion
  const accordionsAll = document.querySelectorAll('[data-accordion="parent"]');
  if (accordionsAll.length > 0) {
    let accordions = new Accordions();
    window.accordions = accordions;
  }

  // Accordion - details
  const accordionDetails = document.querySelectorAll('[data-details]');
  if (accordionDetails.length > 0) {
    accordionDetails.forEach((item) => {
      if (breakPointMobile < window.innerWidth) {
        item.setAttribute('open', '');
      }
    })
  }

  // Tabs
  const tabsAll = document.querySelectorAll('[data-tabs="parent"]');
  if (tabsAll.length > 0) {
    let tabs = new Tabs();
    window.tabs = tabs;
  }

  const dropBoxBtnOpen = document.querySelectorAll('[data-drop-box="open"]');
  const dropBoxBtnPrev = document.querySelectorAll('[data-drop-box="prev"]');

  if (dropBoxBtnOpen.length > 0) {
    dropBoxBtnOpen.forEach((item) => {
      item.addEventListener('click', (evt) => {
        evt.preventDefault();
        const parent = item.closest('[data-drop-box="parent"]');
        if (parent.classList.contains('is-active')) {
          parent.classList.remove('is-active');
          if (breakPointMobile >= window.innerWidth) {
            // scrollLock.enableScrolling();
            focusLock.unlock('[data-drop-box="parent"].is-active [data-drop-box="container"]');
          }
        } else {
          parent.classList.add('is-active');
          if (breakPointMobile >= window.innerWidth) {
            // scrollLock.disableScrolling();
            focusLock.lock('[data-drop-box="parent"].is-active [data-drop-box="container"]');
          }
        }
      });
    });
  }

  if (dropBoxBtnPrev.length > 0) {
    dropBoxBtnPrev.forEach((item) => {
      item.addEventListener('click', (evt) => {
        evt.preventDefault();
        const parent = item.closest('[data-drop-box="parent"].is-active');
        if (parent) {
          parent.classList.remove('is-active');
        }
      });
    });
  }
});
